import React, { useState, useEffect, useRef, useCallback } from 'react';

/* ════════════════════════════════════════════════════════════
   DESIGN TOKENS — clean / light / SaaS style (inspiré softavera.com)
════════════════════════════════════════════════════════════ */
const C = {
  bg:        '#ffffff',
  bgSoft:    '#f7f9fc',
  bgDark:    '#0b1220',
  border:    '#e6e9f0',
  text:      '#0f172a',
  textSoft:  '#5b6472',
  primary:   '#2554f6',
  primaryD:  '#1a3fc9',
  accent:    '#ff7a45',
  green:     '#16a34a',
  gold:      '#f5a524',
};
//76-44

const FONT = "'Inter', 'Segoe UI', -apple-system, sans-serif";

/* ════════════════════════════════════════════════════════════
   DATA — contenu BIDATA
════════════════════════════════════════════════════════════ */
function slugify(str) {
  return String(str)
    .toLowerCase()
    .normalize('NFD').replace(/[\u0300-\u036f]/g, '')
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/(^-|-$)/g, '');
}

/* Liens simples restants dans la navbar (en plus du méga-menu Solutions) */
const SIMPLE_NAV_LINKS = [
  { id: 'avis',    label: 'Avis clients' },
  { id: 'contact', label: 'Contact' },
];

const STATS = [
  { num: '17', label: "ans d'expérience" },
  { num: '9+', label: 'secteurs clients' },
  { num: '4',  label: 'services dédiés' },
  { num: '100%', label: 'accompagnement local' },
];

const PARTNERS = [
  { name: 'Friterie Bapalmoise', src: '/images/friterie-bapalmoise.png' },
  { name: "O'Chicken Cheese",    src: '/images/ochickencheese.png' },
  { name: "O'Miams Régal",       src: '/images/o-miamsregal.png' },
  { name: 'CHB',                 src: '/images/chb.png' },
  { name: 'Homes Pizza',         src: '/images/homespizza.jpg' },
  { name: 'Lusitalia',           src: '/images/lusitalia.png' },
  { name: 'Antalya Kebab',       src: '/images/antalyakebab-food.webp' },
];

const PRODUITS = [
  { title: "Solution d'encaissement", tag: 'Logiciel', color: '#2554f6', colorD: '#1a3fc9',
    img: '/images/Capture.PNG', menuGroup: 'Encaissement', menuIcon: '🧾',
    desc: "Export CSV, top des ventes, gestion des comptes clients, clôtures et reporting envoyé par email.",
    features: [
      'Export CSV et rapports automatiques par email',
      'Top des ventes et statistiques en temps réel',
      'Gestion des comptes et de la fidélité clients',
      'Clôtures de caisse simplifiées, sans erreur',
    ] },
  { title: 'Caisses tactiles', tag: '7 modèles', color: '#2554f6', colorD: '#1a3fc9',
    img: '/images/CAISSES-TACTILES-OVA-png.png', menuGroup: 'Encaissement', menuIcon: '🖥️',
    desc: 'JOON 4/3 - EVOQ 4/3 - PACK OLINK - EVOQ 16/9 - JOON 16/9 - OVA - CAISSE TACTILE X — fiabilité et solidité à la pointe de la technologie.',
    features: [
      '7 modèles selon votre budget et votre espace',
      'Écran tactile réactif, conçu pour un usage intensif',
      'Compatible avec tous nos périphériques',
      'Installation et paramétrage inclus',
    ] ,
  models: [
  {
    name: 'JOON 4/3',
    img: '/images/JOON-4_3-png.png',
    desc: 'Caisse tactile moderne avec écran au format 4:3.',
    points: ['Idéal : commerces de détail, restaurants', 'Forces : format compact, utilisation intuitive']
  },
  {
    name: 'EVOQ 4/3',
    img: '/images/evoq-4_3-png.png',
    desc: 'Solution professionnelle avec écran au format classique 4:3.',
    points: ['Idéal : commerces et points de vente', 'Forces : format pratique, confort d’utilisation']
  },
  {
    name: 'PACK OLINK',
    img: '/images/CAISSE-TACTILE-PACK-OLINK-png.png',
    desc: 'Pack complet de caisse tactile pour faciliter la gestion de votre commerce.',
    points: ['Idéal : commerces, restaurants', 'Forces : solution complète, installation simplifiée']
  },
  {
    name: 'EVOQ 16/9',
    img: '/images/evoq-16-9-png.png',
    desc: 'Caisse tactile professionnelle avec écran panoramique au format 16:9.',
    points: ['Idéal : points de vente modernes', 'Forces : affichage panoramique, espace de travail confortable']
  },
  {
    name: 'JOON 16/9',
    img: '/images/joon-16_9-png.png',
    desc: 'Caisse tactile au design élégant avec écran large au format 16:9.',
    points: ['Idéal : commerces et restaurants', 'Forces : design moderne, affichage large']
  },
  {
    name: 'OVA',
    img: '/images/CAISSES-TACTILES-OVA-png.png',
    desc: 'Caisse tactile conçue pour simplifier et accélérer les opérations d’encaissement.',
    points: ['Idéal : commerces et points de vente', 'Forces : interface intuitive, utilisation rapide']
  },
  {
    name: 'CAISSE TACTILE X',
    img: '/images/CAISSE-TACTILE-X-png.png',
    desc: 'Solution de caisse tactile tout-en-un pour gérer efficacement les opérations quotidiennes.',
    points: ['Idéal : commerces et restaurants', 'Forces : solution intégrée, gain de place']
  }
],},
 
  { title: 'Bornes de commande', tag: 'Indoor / Outdoor',  color: '#2554f6', colorD: '#1a3fc9',
    img: '/images/born.png', menuGroup: 'Prise de commande', menuIcon: '📟',
 desc: 'Kiosk KOYA 21.5", Kiosk KOBÉ 27", Kiosk KOBÉ 32", Kwartz — bornes murales ou autoportantes, pour tous les environnements et tous les budgets.',
features: [
  'Tailles de 21,5 à 32 pouces, murales ou autoportantes',
  'Versions indoor et outdoor résistantes aux intempéries',
  'Réduit l\u2019attente et augmente le panier moyen',
  'Interface personnalisée à votre carte et votre image',
],
  models: [
  { name: 'Kiosk KOYA 21.5"', img: '/images/koya-215.png',
    desc: 'Borne compacte pour les petits espaces, simple à installer.',
    points: ['Idéal : coffee shops, snacks, petits commerces', 'Forces : format compact, prise en main rapide'] },
  { name: 'Kiosk KOBÉ 27"', img: '/images/kobe-27.png',
    desc: 'Format intermédiaire alliant confort de lecture et encombrement réduit.',
    points: ['Idéal : restaurants, boulangeries', 'Forces : bon équilibre taille / budget'] },
  { name: 'Kiosk KOBÉ 32"', img: '/images/kobe-32.png',
    desc: 'Grand écran immersif pour les zones à fort passage.',
    points: ['Idéal : fast-food, centres commerciaux', 'Forces : visibilité maximale, produits mis en valeur'] },
  { name: 'Kwartz', img: '/images/kwartz.png',
    desc: 'Borne de commande autonome pensée pour une expérience client fluide.',
    points: ['Idéal : restauration rapide, points de vente actifs', 'Forces : design moderne, commande autonome'] },
], },
  { title: 'Afficheurs clients', tag: 'Panels PC', color: '#2554f6', colorD: '#1a3fc9',
    img: '/images/SGD100-et-SGDP100-png.png', menuGroup: 'Prise de commande', menuIcon: '📺',
   desc: 'Gamme SGD80, SGD100, SGD200 et SGDP-240 pour une visibilité optimale en caisse.',
features: [
  'Gamme SGD80, SGD100, SGD200 et SGDP-240',
  'Visibilité optimale du détail de la commande',
  'Renforce la transparence et la confiance client',
  'Montage flexible en caisse ou au comptoir',
],
  models: [
  { name: 'SGD80', img: '/images/SGD80-et-SGDP80-png.png',
    desc: 'Afficheur client compact pour montrer le détail de la commande.',
    points: ['Idéal : petits comptoirs', 'Forces : compact, lisible'] },
  { name: 'SGD100', img: '/images/SGD100-et-SGDP100-png.png',
    desc: 'Afficheur client polyvalent pour une bonne visibilité en caisse.',
    points: ['Idéal : commerces standards', 'Forces : visibilité, montage flexible'] },
  { name: 'SGD200', img: '/images/SGD200-ET-SGDP240-png.png',
    desc: 'Grand afficheur pour une transparence maximale côté client.',
    points: ['Idéal : restauration, retail', 'Forces : grand format, confiance client'] },
 {
  name: 'SGDP-240',
  img: '/images/sgpd-240.png',
  desc: 'Afficheur client compact à 2 lignes de 20 caractères, avec tête orientable et connexion USB au terminal de point de vente.',
  points: [
    'Idéal : affichage des informations client à la caisse',
    'Forces : format compact, tête orientable, connexion USB',
    'Options : deux tailles de tubes disponibles',
    'Installation : intégration possible au dos du TPV'
  ]
},
], },
  { title: 'Écrans Cuisine', tag: 'Panels PC / KDS', color: '#2554f6', colorD: '#1a3fc9',
    img: '/images/aures21.png', menuGroup: 'Prise de commande', menuIcon: '👨‍🍳',
    desc: 'Écrans professionnels  et PRIMATIC de 21 pouces et solutions KDS pour afficher et gérer efficacement les commandes en cuisine.',
    features: [
      'Écrans professionnels de 21 pouces',
      'Affichage clair des commandes en cuisine',
      'Gestion et suivi des commandes en temps réel avec le KDS',
      'Solutions adaptées aux environnements de restauration',
    ],
    models: [
      { name: ' Panel 21"', img: '/images/aures21.png',
        desc: 'Écran professionnel  de 21 pouces destiné à une utilisation en cuisine ou en point de vente, selon la configuration.',
        points: [
          'Format : 21 pouces',
          'Marque : ',
          'Utilisation : affichage et gestion des commandes',
          'Installation : selon le modèle',
        ] },
      { name: 'PRIMATIC Panel 21"', img: '/images/primatic-panel-21.png',
        desc: 'Écran professionnel PRIMATIC de 21 pouces conçu pour les environnements de caisse et de restauration.',
        points: [
          'Format : 21 pouces',
          'Marque : PRIMATIC',
          'Utilisation : environnement professionnel',
          'Installation : selon le modèle',
        ] },
      { name: 'KDS – Écran de cuisine', img: '/images/kds.png',
        desc: 'Kitchen Display System permettant au personnel de cuisine de consulter les commandes et de suivre leur préparation sur écran.',
        points: [
          'Affichage des commandes en cuisine',
          'Suivi des commandes en préparation',
          'Organisation du travail en cuisine',
          'Compatibilité : selon le logiciel utilisé',
        ] },
    ],
  },
  { title: 'Imprimantes tickets', tag: 'WiFi & rapides',  color: '#2554f6', colorD: '#1a3fc9',
    img: '/images/SGPR200III-ouvert.png', menuGroup: 'Impression', menuIcon: '🖨️',
    desc: 'SGPR200W, SGPR200II, SGPR300L — impression haute vitesse et grand format.',
    features: [
      'SGPR200W, SGPR200II, SGPR300L au catalogue',
      'Connexion WiFi ou filaire selon vos besoins',
      'Impression haute vitesse, y compris en cuisine',
      'Formats standards et grand format disponibles',
    ],
   models: [
    { name: 'SGPR200W', img: '/images/sgpr200w.png',
      desc: 'Imprimante tickets WiFi, idéale pour le comptoir et la cuisine sans câblage.',
      points: ['Idéal : restauration rapide, food-trucks', 'Forces : connexion WiFi, installation rapide'] },
    { name: 'SGPR200II', img: '/images/SGPR200II.png',
      desc: 'Impression haute vitesse, fiable pour un usage intensif.',
      points: ['Idéal : commerces à forte affluence', 'Forces : rapidité, robustesse'] },
    { name: 'SGPR300L', img: '/images/SGPR300L.png',
      desc: 'Format large pour tickets cuisine, bons de commande et étiquettes.',
      points: ['Idéal : cuisines, logistique', 'Forces : grand format, lisibilité'] },
  ] },
  { title: 'Périphériques', tag: 'Tiroirs-caisses',  color: '#2554f6', colorD: '#1a3fc9',
    img: '/images/SGDK410.png', menuGroup: 'Encaissement', menuIcon: '🗄️',
    desc: 'SGDK330, SGDK170, SGDK410 — robustes, sécurisés et grande capacité.',
    features: [
      'SGDK330, SGDK170, SGDK410 selon vos volumes',
      'Fermeture sécurisée et compartiments modulables',
      'Robustesse éprouvée pour un usage quotidien intensif',
      'Compatible avec l\u2019ensemble de nos caisses',
    ] ,
  models: [
  { name: 'SGDK330', img: '/images/sgdk330.png',
    desc: 'Tiroir-caisse robuste et sécurisé pour un usage quotidien.',
    points: ['Idéal : commerces standards', 'Forces : robustesse, fermeture sécurisée'] },
  { name: 'SGDK170', img: '/images/sgdk170.png',
    desc: 'Tiroir-caisse compact pour les comptoirs limités en espace.',
    points: ['Idéal : petits comptoirs', 'Forces : format compact, simplicité'] },
  { name: 'SGDK410', img: '/images/sgdk410.png',
    desc: 'Tiroir-caisse grande capacité pour les volumes importants.',
    points: ['Idéal : forte activité', 'Forces : grande capacité, compartiments modulables'] },
]},
        { title: 'Monnayeur', tag: 'Poids-prix', color: '#2554f6', colorD: '#1a3fc9',
    img: '/images/Monnayeur.png', menuGroup: 'Pesage & Lecture', menuIcon: '⚖️',
    desc: 'Glory CI-10X, Glory CI-10 — monnayeur automatique connecté à votre caisse pour un encaissement rapide, sécurisé et une gestion simplifiée des espèces.',
  features: [
    'Encaissement automatique et rendu de monnaie précis',
    'Connexion directe à votre caisse tactile',
    'Gestion automatisée des billets et des pièces',
    'Réduction des erreurs de caisse et des écarts de trésorerie',
    'Sécurisation des espèces et gain de temps en caisse',
    'Installation et paramétrage inclus',
  ], models: [
  { name: 'Glory CI-10X', img: '/images/Monnayeur.png',
    desc: 'Monnayeur automatique connecté à votre caisse pour un encaissement sécurisé.',
    points: ['Idéal : commerces à fort volume d\u2019espèces', 'Forces : rapidité, rendu de monnaie précis'] },
  { name: 'Glory CI-10', img: '/images/ci10X.jpg',
    desc: 'Monnayeur fiable pour simplifier la gestion des espèces.',
    points: ['Idéal : commerces de tous formats', 'Forces : fiabilité, réduction des erreurs de caisse'] },
] },
    { title: 'Scanners', tag: 'Code-barres', color: '#2554f6', colorD: '#1a3fc9',
    img: '/images/scanner1.png', menuGroup: 'Pesage & Lecture', menuIcon: '🔍',
     desc: 'Glory CI-10X, Glory CI-10 — monnayeur automatique connecté à votre caisse pour un encaissement rapide, sécurisé et une gestion simplifiée des espèces.',
  features: [
    'Encaissement automatique et rendu de monnaie précis',
    'Connexion directe à votre caisse tactile',
    'Gestion automatisée des billets et des pièces',
    'Réduction des erreurs de caisse et des écarts de trésorerie',
    'Sécurisation des espèces et gain de temps en caisse',
    'Installation et paramétrage inclus',
  ], models: [
  { name: 'SGBS-550i', img: '/images/scanner1.png',
    desc: 'Lecteur de codes-barres rapide pour accélérer l\u2019encaissement.',
    points: ['Idéal : commerces de détail', 'Forces : lecture rapide, fiabilité'] },
  { name: 'SGBS-900-W', img: '/images/SGBS-900-W.png',
    desc: 'Scanner sans fil pour plus de liberté de mouvement.',
    points: ['Idéal : grandes surfaces, inventaires', 'Forces : sans fil, mobilité'] },
  { name: 'SGBS 400', img: '/images/SGBS400.png',
    desc: 'Scanner simple et économique pour un usage quotidien.',
    points: ['Idéal : petits commerces', 'Forces : simplicité, bon rapport qualité / prix'] },
  { name: 'SGBC 2D', img: '/images/SGBC2D.png',
    desc: 'Lecteur 2D capable de lire QR codes et codes-barres classiques.',
    points: ['Idéal : fidélité, coupons, paiement mobile', 'Forces : lecture 1D / 2D'] },
], },
];

const SECTEURS = [
  { name: 'Restauration ', desc: 'Fluidifiez le rush et boostez votre chiffre d\u2019affaires.', icon: '',
    img: '/metiers/restau-rapide.jpg',
    features: ['Bornes de commande pour absorber le rush', 'Caisse tactile pensée pour la cadence', 'Tickets cuisine imprimés instantanément'] },
  { name: 'Boulangerie',         desc: 'Commande, paiement et gestion des recettes simplifiés.', icon: '',
    img: '/metiers/boulangerie.jpg',
    features: ['Encaissement rapide au comptoir', 'Gestion des recettes et du petit-déjeuner', 'Reporting quotidien envoyé par email'] },
  { name: 'Boucherie',           desc: 'Encaissement précis, traçabilité, stocks en temps réel.', icon: '',
    img: '/metiers/boucherie.jpg',
    features: ['Vente au poids et à la pièce précise', 'Suivi des stocks en temps réel', 'Traçabilité des produits simplifiée'] },
  { name: 'Poissonnerie',        desc: 'Vente à la coupe et au poids, sans friction.', icon: '',
    img: '/metiers/poissonnerie.jpg',
    features: ['Pesée et vente à la coupe fluides', 'Étiquetage et prix simplifiés', 'Caisse adaptée à un usage humide et intensif'] },
  { name: 'Esthétique & Beauté', desc: 'Rendez-vous, fidélité et encaissement centralisé.', icon: '',
    img: '/metiers/esthetique.jpg',
    features: ['Prise de rendez-vous centralisée', 'Programme de fidélité intégré', 'Encaissement rapide en fin de prestation'] },
  { name: 'Coiffeur',            desc: 'Caisse intuitive et suivi de performance.', icon: '',
    img: '/metiers/coiffeur.jpg',
    features: ['Caisse intuitive pour toute l\u2019équipe', 'Suivi de la performance par coiffeur', 'Fidélisation de la clientèle facilitée'] },
  { name: 'Pharmacies',          desc: 'Interface conforme aux spécificités du métier.', icon: '',
    img: '/metiers/pharmacie.jpg',
    features: ['Interface conforme aux exigences du secteur', 'Encaissement rapide en période d\u2019affluence', 'Support technique réactif et dédié'] },
  { name: 'Pizzeria',            desc: 'Commande rapide, livraison, intégrations plateformes.', icon: '',
    img: '/metiers/pizzeria.jpg',
    features: ['Commande rapide en salle et à emporter', 'Gestion de la livraison simplifiée', 'Intégrations avec les plateformes de commande'] },
  { name: 'Pâtisserie',          desc: 'Commande, stocks et encaissement rapide.', icon: '',
    img: '/metiers/pâtisserie .jpg',
    features: ['Encaissement rapide aux heures de pointe', 'Gestion des stocks et des commandes spéciales', 'Reporting des ventes en temps réel'] },
];

const SERVICES = [
  { icon: '🏪', title: 'Installation sur site', desc: "Nous installons vos systèmes de caisse directement dans votre point de vente. Inclus avec toutes nos bornes de commande.",
    features: ['Déplacement et installation par nos équipes', 'Inclus avec toutes nos bornes de commande', 'Mise en service testée avant notre départ'] },
  { icon: '⚙️', title: 'Paramétrage personnalisé', desc: "Nous intégrons votre carte, vos offres et toutes les spécificités de votre établissement.",
    features: ['Intégration complète de votre carte et vos offres', 'Adapté aux spécificités de votre établissement', 'Mises à jour de paramétrage sans frais additionnels'] },
  { icon: '👨\u200d🏫', title: 'Formation', desc: "Vos équipes formées à l'utilisation de nos logiciels — sur site, à distance ou dans nos locaux.",
    features: ['Formation sur site, à distance ou dans nos locaux', 'Prise en main rapide pour toute l\u2019équipe', 'Supports de formation fournis'] },
  { icon: '🛠️', title: 'Support technique', desc: "Un support ouvert de 9h30 à 19h pour vous assister et prendre la main à distance si besoin.",
    features: ['Support ouvert de 9h30 à 19h', 'Prise en main à distance en cas de besoin', 'Un vrai interlocuteur, pas un chatbot'] },
];

/* Méga-menu "Solutions" — regroupe PRODUITS (par catégorie) + SERVICES,
   à la manière du menu Solutions de softavera.com */
const GROUP_ICONS = {
  'Prise de commande': '',
  'Encaissement':       '',
  'Impression':         '',
  'Pesage & Lecture':   '',
};

const SOLUTIONS_MENU = [
  ...['Prise de commande', 'Encaissement', 'Impression','Pesage & Lecture'].map(group => ({
    icon: GROUP_ICONS[group],
    title: group,
    items: PRODUITS
      .filter(p => p.menuGroup === group)
      .map(p => ({ label: p.title, slug: slugify(p.title), type: 'produit' })),
  })),
  {
    icon: '',
    title: 'Accompagnement',
    items: SERVICES.map(s => ({ label: s.title, slug: slugify(s.title), type: 'service' })),
  },
];

/* Méga-menu "Métiers" — un item par secteur */
const METIERS_MENU = [
  {
    icon: '',
    title: 'Nos secteurs',
    items: SECTEURS.map(s => ({ label: s.name, slug: slugify(s.name), type: 'secteur' })),
  },
];

/* Recherche d'une fiche (produit / service / secteur) par type + slug, pour le routing */
function findSolutionItem(type, slug) {
  const source = type === 'produit' ? PRODUITS : type === 'service' ? SERVICES : type === 'secteur' ? SECTEURS : [];
  const key = type === 'secteur' ? 'name' : 'title';
  return source.find(item => slugify(item[key]) === slug) || null;   
}

const STEPS = [
  { num: '1', title: 'Analyse de vos besoins', desc: "Nous prenons le temps de comprendre votre activité, vos contraintes et vos objectifs." },
  { num: '2', title: 'Proposition sur mesure', desc: 'Une offre claire, adaptée à votre budget — sans superflu.' },
  { num: '3', title: 'Préparation & paramétrage', desc: 'Catalogue, utilisateurs, périphériques : tout est prêt avant notre arrivée.' },
  { num: '4', title: 'Mise en place & formation', desc: 'Installation et formation sur site. Opérationnel dès le jour même.' },
  { num: '5', title: 'Assistance au quotidien', desc: 'Un vrai interlocuteur joignable, pas un chatbot.' },
  { num: '6', title: 'Évolution & mises à jour', desc: 'Des améliorations régulières, sans frais supplémentaires.' },
];

const POINTS_FORTS = [
  { icon: '🥇', title: 'Simplicité',     desc: 'Une prise en main intuitive dès le premier jour.' },
  { icon: '🚀', title: 'Innovation',     desc: 'Des solutions à la pointe, mises à jour en continu.' },
  { icon: '⚡', title: 'Performance',    desc: 'Fiabilité maximale et temps de réponse ultra-rapides.' },
  { icon: '🤝', title: 'Accompagnement', desc: 'Un support humain disponible de 9h30 à 19h.' },
];

const TEMOIGNAGES = [
  { text: "Une solution complète et facile à prendre en main. Nos équipes ont été opérationnelles dès le premier jour.", author: 'Restaurateur, Île-de-France', stars: 5 },
  { text: "Le support technique est réactif et toujours à l'écoute. Chaque problème est résolu rapidement.", author: 'Gérant de boulangerie', stars: 5 },
  { text: "Une interface intuitive, des rapports clairs et un accompagnement de qualité du début à la fin.", author: 'Franchise fast-food', stars: 5 },
];

/* ════════════════════════════════════════════════════════════
   HOOKS UTILITAIRES
════════════════════════════════════════════════════════════ */
function useReveal(threshold = 0.15) {
  const ref = useRef(null);
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    const obs = new IntersectionObserver(([e]) => {
      if (e.isIntersecting) { setVisible(true); obs.disconnect(); }
    }, { threshold });
    obs.observe(el);
    return () => obs.disconnect();
  }, [threshold]);
  return [ref, visible];
}

function useIsMobile() {
  const [isMobile, setIsMobile] = useState(false);
  useEffect(() => {
    const check = () => setIsMobile(window.innerWidth < 860);
    check();
    window.addEventListener('resize', check);
    return () => window.removeEventListener('resize', check);
  }, []);
  return isMobile;
}

/* ════════════════════════════════════════════════════════════
   PETITS COMPOSANTS
════════════════════════════════════════════════════════════ */
function Eyebrow({ children }) {
  return (
    <div style={{
      display: 'inline-flex', alignItems: 'center', gap: 8,
      padding: '6px 14px', borderRadius: 999,
      background: 'rgba(37,84,246,0.08)', border: `1px solid rgba(37,84,246,0.18)`,
      color: C.primary, fontSize: 13, fontWeight: 700, letterSpacing: '0.4px',
      marginBottom: 18,
    }}>
      <span style={{ width: 6, height: 6, borderRadius: '50%', background: C.primary }} />
      {children}
    </div>
  );
}

function SectionHead({ eyebrow, title, subtitle, center = true, dark = false }) {
  const [ref, vis] = useReveal();
  return (
    <div ref={ref} style={{
      textAlign: center ? 'center' : 'left',
      maxWidth: center ? 700 : 640,
      margin: center ? '0 auto clamp(40px,6vw,64px)' : '0 0 clamp(40px,6vw,64px)',
      opacity: vis ? 1 : 0, transform: vis ? 'none' : 'translateY(24px)',
      transition: 'opacity 0.7s ease, transform 0.7s ease',
    }}>
      {eyebrow && <Eyebrow>{eyebrow}</Eyebrow>}
      <h2 style={{
        margin: '0 0 14px', fontSize: 'clamp(28px,4.2vw,42px)', fontWeight: 800,
        letterSpacing: '-0.02em', lineHeight: 1.15,
        color: dark ? '#fff' : C.text,
      }}>{title}</h2>
      {subtitle && (
        <p style={{ margin: 0, fontSize: 'clamp(15px,1.8vw,18px)', lineHeight: 1.6,
          color: dark ? 'rgba(255,255,255,0.7)' : C.textSoft }}>{subtitle}</p>
      )}
    </div>
  );
}

function PrimaryButton({ children, onClick, big }) {
  const [hov, setHov] = useState(false);
  return (
    <button onClick={onClick} onMouseEnter={() => setHov(true)} onMouseLeave={() => setHov(false)}
      style={{
        display: 'inline-flex', alignItems: 'center', gap: 8,
        padding: big ? '16px 30px' : '12px 24px', borderRadius: 12, border: 'none',
        background: hov ? C.primaryD : C.primary, color: '#fff', cursor: 'pointer',
        fontSize: big ? 16 : 14.5, fontWeight: 700, fontFamily: FONT,
        boxShadow: hov ? '0 12px 28px rgba(37,84,246,0.35)' : '0 6px 18px rgba(37,84,246,0.22)',
        transform: hov ? 'translateY(-2px)' : 'none',
        transition: 'all 0.25s ease',
      }}>{children}</button>
  );
}

function SecondaryButton({ children, onClick, big }) {
  const [hov, setHov] = useState(false);
  return (
    <button onClick={onClick} onMouseEnter={() => setHov(true)} onMouseLeave={() => setHov(false)}
      style={{
        display: 'inline-flex', alignItems: 'center', gap: 8,
        padding: big ? '16px 30px' : '12px 24px', borderRadius: 12,
        border: `1.5px solid ${hov ? C.primary : C.border}`,
        background: hov ? 'rgba(37,84,246,0.05)' : '#fff', color: C.text, cursor: 'pointer',
        fontSize: big ? 16 : 14.5, fontWeight: 700, fontFamily: FONT,
        transition: 'all 0.25s ease',
      }}>{children}</button>
  );
}

function Card({ children, style, hoverLift = true, onClick }) {
  const [hov, setHov] = useState(false);
  return (
    <div onMouseEnter={() => hoverLift && setHov(true)} onMouseLeave={() => setHov(false)} onClick={onClick}
      style={{
        background: '#fff', borderRadius: 20, border: `1px solid ${C.border}`,
        boxShadow: hov ? '0 20px 44px -14px rgba(15,23,42,0.16)' : '0 2px 10px rgba(15,23,42,0.04)',
        transform: hov ? 'translateY(-6px)' : 'none',
        transition: 'all 0.35s cubic-bezier(0.22,1,0.36,1)',
        ...style,
      }}>
      {children}
    </div>
  );
}

/* ════════════════════════════════════════════════════════════
   NAVBAR
════════════════════════════════════════════════════════════ */
const navBtnStyle = {
  background: 'transparent', border: 'none', cursor: 'pointer',
  padding: '9px 14px', borderRadius: 8, fontSize: 14.5, fontWeight: 600,
  color: C.textSoft, fontFamily: FONT, transition: 'all 0.2s ease',
  display: 'flex', alignItems: 'center', gap: 6,
};

/* Méga-menu déroulant (desktop) — plusieurs colonnes de catégories + items,
   ouvre au survol/clic comme sur softavera.com */
function MegaMenu({ label, groups, onSelect }) {
  const [open, setOpen] = useState(false);
  const closeTimer = useRef(null);
  const cancelClose = () => { if (closeTimer.current) clearTimeout(closeTimer.current); };
  const scheduleClose = () => { closeTimer.current = setTimeout(() => setOpen(false), 160); };
  useEffect(() => () => cancelClose(), []);

  return (
    <div
      onMouseEnter={() => { cancelClose(); setOpen(true); }}
      onMouseLeave={scheduleClose}
      style={{ position: 'relative' }}
    >
      <button
        onClick={() => setOpen(v => !v)}
        style={{ ...navBtnStyle, color: open ? C.text : C.textSoft, background: open ? C.bgSoft : 'transparent' }}
      >
        {label}
        <span style={{ fontSize: 10, transform: open ? 'rotate(180deg)' : 'none', transition: 'transform 0.2s ease' }}>▾</span>
      </button>

      {open && (
        <div style={{
          position: 'absolute', top: 'calc(100% + 16px)', left: '50%', transform: 'translateX(-50%)',
          background: '#fff', border: `1px solid ${C.border}`, borderRadius: 18,
          boxShadow: '0 30px 70px -20px rgba(15,23,42,0.28)', padding: '26px 28px',
          display: 'grid', gap: 34, zIndex: 1200,
          gridTemplateColumns: `repeat(${groups.length}, minmax(190px, 1fr))`,
        }}>
          {groups.map((g, i) => (
            <div key={i}>
              <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 14 }}>
                <span style={{ fontSize: 16 }}>{g.icon}</span>
                <span style={{ fontSize: 13, fontWeight: 800, color: C.text, whiteSpace: 'nowrap' }}>{g.title}</span>
              </div>
              <div style={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
                {g.items.map((it, j) => (
                  <button key={j}
                    onClick={() => { setOpen(false); onSelect(it.type, it.slug); }}
                    style={{
                      textAlign: 'left', background: 'transparent', border: 'none', cursor: 'pointer',
                      padding: '7px 9px', borderRadius: 8, fontSize: 13.5, color: C.textSoft,
                      fontFamily: FONT, transition: 'all 0.15s ease', whiteSpace: 'nowrap',
                    }}
                    onMouseEnter={e => { e.currentTarget.style.color = C.primary; e.currentTarget.style.background = C.bgSoft; }}
                    onMouseLeave={e => { e.currentTarget.style.color = C.textSoft; e.currentTarget.style.background = 'transparent'; }}
                  >{it.label}</button>
                ))}
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}

/* Accordéon mobile pour un méga-menu */
function MobileMenuAccordion({ label, groups, onSelect }) {
  const [open, setOpen] = useState(false);
  return (
    <div>
      <button onClick={() => setOpen(v => !v)} style={{
        width: '100%', textAlign: 'left', display: 'flex', alignItems: 'center', justifyContent: 'space-between',
        padding: '12px 14px', borderRadius: 10, border: 'none', background: 'transparent',
        fontSize: 15, fontWeight: 700, color: C.text, fontFamily: FONT, cursor: 'pointer',
      }}>
        {label}
        <span style={{ fontSize: 11, transform: open ? 'rotate(180deg)' : 'none', transition: 'transform 0.2s ease' }}>▾</span>
      </button>
      {open && (
        <div style={{ padding: '2px 10px 10px 20px', display: 'flex', flexDirection: 'column', gap: 14 }}>
          {groups.map((g, i) => (
            <div key={i}>
              <div style={{ fontSize: 11.5, fontWeight: 800, letterSpacing: '0.4px', textTransform: 'uppercase', color: C.textSoft, marginBottom: 6 }}>
                {g.icon} {g.title}
              </div>
              <div style={{ display: 'flex', flexDirection: 'column' }}>
                {g.items.map((it, j) => (
                  <button key={j} onClick={() => onSelect(it.type, it.slug)} style={{
                    textAlign: 'left', padding: '8px 6px', border: 'none', background: 'transparent',
                    fontSize: 14, color: C.text, fontFamily: FONT, cursor: 'pointer',
                  }}>{it.label}</button>
                ))}
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}

function Navbar({ isMobile, onNav, onContact, onGoHome, onSelectItem }) {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  useEffect(() => {
    const fn = () => setScrolled(window.scrollY > 20);
    window.addEventListener('scroll', fn, { passive: true });
    return () => window.removeEventListener('scroll', fn);
  }, []);
  const go = useCallback((id) => { setMenuOpen(false); onNav(id); }, [onNav]);
  const selectItem = useCallback((type, slug) => { setMenuOpen(false); onSelectItem(type, slug); }, [onSelectItem]);

  return (
    <header style={{
      position: 'fixed', top: 0, left: 0, right: 0, zIndex: 1000,
      background: scrolled ? 'rgba(255,255,255,0.92)' : 'rgba(255,255,255,0.75)',
      backdropFilter: 'blur(14px) saturate(180%)',
      borderBottom: `1px solid ${scrolled ? C.border : 'transparent'}`,
      transition: 'all 0.25s ease',
    }}>
      <div style={{
        maxWidth: 1280, margin: '0 auto', padding: '0 clamp(16px,4vw,32px)',
        height: 72, display: 'flex', alignItems: 'center', justifyContent: 'space-between',
      }}>
        {/* Logo */}
        <div onClick={onGoHome} style={{ display: 'flex', alignItems: 'center', gap: 10, cursor: 'pointer' }}>
          <img src="images/l.png" alt="Bi Data" style={{ height: 64, width: 'auto', objectFit: 'contain' }} />
        </div>

        {!isMobile && (
          <nav style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
            <MegaMenu label="Solutions" groups={SOLUTIONS_MENU} onSelect={selectItem} />
            <MegaMenu label="Métiers" groups={METIERS_MENU} onSelect={selectItem} />
            {SIMPLE_NAV_LINKS.map(l => (
              <button key={l.id} onClick={() => go(l.id)}
                style={navBtnStyle}
                onMouseEnter={e => { e.currentTarget.style.color = C.text; e.currentTarget.style.background = C.bgSoft; }}
                onMouseLeave={e => { e.currentTarget.style.color = C.textSoft; e.currentTarget.style.background = 'transparent'; }}
              >{l.label}</button>
            ))}
          </nav>
        )}

        {!isMobile ? (
          <PrimaryButton onClick={onContact}>Nous contacter</PrimaryButton>
        ) : (
          <button onClick={() => setMenuOpen(v => !v)} style={{
            width: 40, height: 40, borderRadius: 10, border: `1px solid ${C.border}`,
            background: '#fff', fontSize: 18, cursor: 'pointer',
          }}>{menuOpen ? '✕' : '☰'}</button>
        )}
      </div>

      {isMobile && menuOpen && (
        <div style={{
          background: '#fff', borderTop: `1px solid ${C.border}`,
          padding: 16, display: 'flex', flexDirection: 'column', gap: 4, maxHeight: '75vh', overflowY: 'auto',
        }}>
          <MobileMenuAccordion label="Solutions" groups={SOLUTIONS_MENU} onSelect={selectItem} />
          <MobileMenuAccordion label="Métiers" groups={METIERS_MENU} onSelect={selectItem} />
          {SIMPLE_NAV_LINKS.map(l => (
            <button key={l.id} onClick={() => go(l.id)} style={{
              textAlign: 'left', padding: '12px 14px', borderRadius: 10, border: 'none',
              background: 'transparent', fontSize: 15, fontWeight: 600, color: C.text,
              fontFamily: FONT, cursor: 'pointer',
            }}>{l.label}</button>
          ))}
          <div style={{ marginTop: 8 }}>
            <PrimaryButton onClick={onContact}>Nous contacter</PrimaryButton>
          </div>
        </div>
      )}
    </header>
  );
}

/* ════════════════════════════════════════════════════════════
   HERO
════════════════════════════════════════════════════════════ */
function Hero({ isMobile, onContact, onNav }) {
  const [loaded, setLoaded] = useState(false);
  useEffect(() => { const t = setTimeout(() => setLoaded(true), 80); return () => clearTimeout(t); }, []);

  return (
    <section id="accueil" style={{
      position: 'relative', paddingTop: isMobile ? 120 : 160, paddingBottom: isMobile ? 60 : 100,
      paddingLeft: 'clamp(16px,5vw,32px)', paddingRight: 'clamp(16px,5vw,32px)',
      overflow: 'hidden',
    }}>
      {/* background video */}
      <video autoPlay muted loop playsInline style={{
        position: 'absolute', inset: 0, width: '100%', height: '100%',
        objectFit: 'cover', zIndex: 0, pointerEvents: 'none',
      }}>
        <source src="/borne.mp4" type="video/mp4" />
      </video>

      {/* light overlay so text stays readable on top of the video */}
      <div style={{
        position: 'absolute', inset: 0, zIndex: 1, pointerEvents: 'none',
        background: `linear-gradient(180deg, rgba(255,255,255,0.93) 0%, rgba(255,255,255,0.88) 55%, ${C.bg} 100%)`,
      }} />
      <div style={{
        position: 'absolute', inset: 0, zIndex: 1, pointerEvents: 'none',
        background: 'radial-gradient(1100px 500px at 50% -10%, rgba(37,84,246,0.10), transparent 60%)',
      }} />
      {/* decorative blobs */}
      <div style={{ position: 'absolute', top: -60, right: '8%', width: 320, height: 320, borderRadius: '50%',
        background: 'radial-gradient(circle, rgba(37,84,246,0.12), transparent 70%)', filter: 'blur(10px)', pointerEvents: 'none' }} />
      <div style={{ position: 'absolute', bottom: -80, left: '4%', width: 260, height: 260, borderRadius: '50%',
        background: 'radial-gradient(circle, rgba(255,122,69,0.10), transparent 70%)', filter: 'blur(10px)', pointerEvents: 'none' }} />

      <div style={{ maxWidth: 1280, margin: '0 auto', position: 'relative', zIndex: 2, textAlign: 'center' }}>
        <div style={{ opacity: loaded ? 1 : 0, transform: loaded ? 'none' : 'translateY(18px)', transition: 'all 0.7s ease' }}>
          <Eyebrow>17 ans d'expertise en solutions d'encaissement</Eyebrow>
        </div>

        <h1 style={{
          margin: '0 0 22px', fontWeight: 900, letterSpacing: '-0.03em', lineHeight: 1.08,
          fontSize: 'clamp(34px,6vw,64px)', color: C.text,
          opacity: loaded ? 1 : 0, transform: loaded ? 'none' : 'translateY(24px)',
          transition: 'all 0.8s ease 0.1s',
        }}>
          La caisse, les bornes et le<br />click &amp; collect pour votre commerce
        </h1>

        <p style={{
          margin: '0 auto 36px', maxWidth: 640, fontSize: 'clamp(15px,2vw,19px)',
          color: C.textSoft, lineHeight: 1.65,
          opacity: loaded ? 1 : 0, transform: loaded ? 'none' : 'translateY(24px)',
          transition: 'all 0.8s ease 0.2s',
        }}>
          Bi Data équipe et accompagne les commerçants avec des systèmes d'encaissement
          accessibles, fiables et complets — installation, formation et support inclus.
        </p>

        <div style={{
          display: 'flex', gap: 14, justifyContent: 'center', flexWrap: 'wrap', marginBottom: 56,
          opacity: loaded ? 1 : 0, transform: loaded ? 'none' : 'translateY(24px)',
          transition: 'all 0.8s ease 0.3s',
        }}>
          <PrimaryButton big onClick={() => onNav('produits')}>Découvrir nos produits →</PrimaryButton>
          <SecondaryButton big onClick={onContact}>✉️ Demander un devis</SecondaryButton>
        </div>

        {/* Stats bar */}
        <div style={{
          display: 'flex', flexWrap: 'wrap', justifyContent: 'center', gap: 0,
          background: '#fff', border: `1px solid ${C.border}`, borderRadius: 20,
          boxShadow: '0 20px 50px -20px rgba(15,23,42,0.15)',
          maxWidth: 820, margin: '0 auto', overflow: 'hidden',
          opacity: loaded ? 1 : 0, transform: loaded ? 'none' : 'translateY(24px)',
          transition: 'all 0.8s ease 0.4s',
        }}>
          {STATS.map((s, i) => (
            <div key={i} style={{
              flex: '1 1 160px', padding: '26px 18px',
              borderRight: i < STATS.length - 1 && !isMobile ? `1px solid ${C.border}` : 'none',
              borderBottom: isMobile && i < STATS.length - 1 ? `1px solid ${C.border}` : 'none',
            }}>
              <div style={{ fontSize: 'clamp(26px,3.4vw,34px)', fontWeight: 900, color: C.primary, letterSpacing: '-0.02em' }}>{s.num}</div>
              <div style={{ fontSize: 12.5, color: C.textSoft, fontWeight: 600, marginTop: 4 }}>{s.label}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

/* ════════════════════════════════════════════════════════════
   MARQUEE PARTENAIRES
════════════════════════════════════════════════════════════ */
function PartnersMarquee() {
  const loop = [...PARTNERS, ...PARTNERS, ...PARTNERS];
  return (
    <section style={{ padding: '36px 0', background: C.bgSoft, borderTop: `1px solid ${C.border}`, borderBottom: `1px solid ${C.border}`, overflow: 'hidden' }}>
      <p style={{ textAlign: 'center', fontSize: 12, fontWeight: 700, letterSpacing: '1.5px',
        textTransform: 'uppercase', color: C.textSoft, marginBottom: 22 }}>
        Ils nous font confiance
      </p>
      <div style={{ position: 'relative', overflow: 'hidden' }}>
        {/* fade edges */}
        <div style={{ position: 'absolute', top: 0, bottom: 0, left: 0, width: 100, zIndex: 2,
          background: `linear-gradient(to right, ${C.bgSoft}, transparent)`, pointerEvents: 'none' }} />
        <div style={{ position: 'absolute', top: 0, bottom: 0, right: 0, width: 100, zIndex: 2,
          background: `linear-gradient(to left, ${C.bgSoft}, transparent)`, pointerEvents: 'none' }} />

        <div style={{
          display: 'flex', gap: 44, width: 'max-content', alignItems: 'center',
          animation: 'marquee 26s linear infinite',
        }}>
          {loop.map((p, i) => (
            <div key={i} style={{
              flexShrink: 0, width: 220, height: 130,
              display: 'flex', alignItems: 'center', justifyContent: 'center',
            }}>
              <img src={p.src} alt={p.name} title={p.name}
                style={{ maxWidth: '100%', maxHeight: '100%', objectFit: 'contain' }}
                onError={(e) => { e.target.style.display = 'none'; }} />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

/* ════════════════════════════════════════════════════════════
   PRODUITS
════════════════════════════════════════════════════════════ */
function ProductCard({ p, onOpen }) {
  const [hov, setHov] = useState(false);
  return (
    <div
      onMouseEnter={() => setHov(true)}
      onMouseLeave={() => setHov(false)}
      onClick={onOpen}
      role="button" tabIndex={0}
      style={{
        position: 'relative', borderRadius: 24, overflow: 'hidden',
        padding: '30px 28px', minHeight: 230, cursor: onOpen ? 'pointer' : 'default',
        background: `linear-gradient(135deg, ${p.color} 0%, ${p.colorD} 100%)`,
        boxShadow: hov ? `0 20px 44px -14px ${p.color}88` : `0 10px 26px -12px ${p.color}55`,
        transform: hov ? 'translateY(-6px)' : 'none',
        transition: 'all 0.35s cubic-bezier(0.22,1,0.36,1)',
        display: 'flex', flexDirection: 'column',
      }}
    >
      {/* faint decorative circles like the reference */}
      <div style={{ position: 'absolute', top: -40, right: -30, width: 160, height: 160, borderRadius: '50%',
        background: 'rgba(255,255,255,0.08)', pointerEvents: 'none' }} />
      <div style={{ position: 'absolute', bottom: -60, right: 40, width: 120, height: 120, borderRadius: '50%',
        background: 'rgba(255,255,255,0.06)', pointerEvents: 'none' }} />

      {/* text */}
      <div style={{ position: 'relative', zIndex: 2, maxWidth: '58%' }}>
        <h3 style={{ margin: '0 0 12px', fontSize: 21, fontWeight: 800, color: '#fff', lineHeight: 1.25 }}>
          {p.title}
        </h3>
        <p style={{ margin: 0, fontSize: 13.5, color: 'rgba(255,255,255,0.88)', lineHeight: 1.6 }}>
          {p.desc}
        </p>
      </div>

      {/* product image, overlapping bottom-right like the reference */}
      <div style={{
        position: 'absolute', right: 10, bottom: 0, width: '46%', height: '82%',
        display: 'flex', alignItems: 'flex-end', justifyContent: 'center',
        zIndex: 1, pointerEvents: 'none',
      }}>
        <img src={p.img} alt={p.title}
          style={{
            maxWidth: '100%', maxHeight: '100%', objectFit: 'contain',
            filter: 'drop-shadow(0 14px 20px rgba(0,0,0,0.28))',
            transform: hov ? 'scale(1.05)' : 'scale(1)',
            transition: 'transform 0.35s ease',
          }}
          onError={(e) => { e.target.style.display = 'none'; }}
        />
      </div>
    </div>
  );
}

function ProduitsSection({ isMobile, onContact, onSelectItem }) {
  return (
    <section id="produits" style={{ padding: 'clamp(70px,10vw,110px) clamp(16px,5vw,32px)', background: C.bgSoft }}>
      <div style={{ maxWidth: 1280, margin: '0 auto' }}>
        <SectionHead eyebrow="Notre gamme" title="Nos produits"
          subtitle="Chaque solution peut fonctionner seule, mais la vraie valeur vient de leur connexion." />
        <div style={{
          display: 'grid',
          gridTemplateColumns: isMobile ? '1fr' : 'repeat(3, 1fr)',
          gap: 22,
        }}>
          {PRODUITS.map((p, i) => (
            <ProductCard key={i} p={p} onOpen={onSelectItem ? () => onSelectItem('produit', slugify(p.title)) : undefined} />
          ))}
        </div>
        <div style={{ textAlign: 'center', marginTop: 44 }}>
          <PrimaryButton big onClick={onContact}>Demander un catalogue complet →</PrimaryButton>
        </div>
      </div>
    </section>
  );
}
/* ════════════════════════════════════════════════════════════
   SECTEURS
════════════════════════════════════════════════════════════ */
function SecteurCard({ s, onOpen }) {
  const [hov, setHov] = useState(false);
  return (
    <div
      onMouseEnter={() => setHov(true)}
      onMouseLeave={() => setHov(false)}
      onClick={onOpen}
      role="button" tabIndex={0}
      style={{
        position: 'relative', borderRadius: 24, overflow: 'hidden',
        minHeight: 280, cursor: onOpen ? 'pointer' : 'default',
        background: `linear-gradient(135deg, ${C.primary} 0%, ${C.primaryD} 100%)`,
        boxShadow: hov ? '0 20px 44px -14px rgba(37,84,246,0.55)' : '0 10px 26px -12px rgba(37,84,246,0.35)',
        transform: hov ? 'translateY(-6px)' : 'none',
        transition: 'all 0.35s cubic-bezier(0.22,1,0.36,1)',
        display: 'flex', flexDirection: 'column', justifyContent: 'flex-end',
      }}
    >
      {/* photo plein cadre */}
      <img src={s.img} alt={s.name}
        style={{
          position: 'absolute', inset: 0, width: '100%', height: '100%',
          objectFit: 'cover', zIndex: 0,
          transform: hov ? 'scale(1.08)' : 'scale(1)',
          transition: 'transform 0.6s ease',
        }}
        onError={(e) => { e.target.style.display = 'none'; }}
      />

      {/* voile dégradé pour la lisibilité du texte */}
      <div style={{
        position: 'absolute', inset: 0, zIndex: 1, pointerEvents: 'none',
        background: 'linear-gradient(180deg, rgba(11,18,32,0.05) 30%, rgba(11,18,32,0.88) 100%)',
      }} />

      {/* texte */}
      <div style={{ position: 'relative', zIndex: 2, padding: '26px 26px 24px' }}>
        <h3 style={{ margin: '0 0 8px', fontSize: 21, fontWeight: 800, color: '#fff', lineHeight: 1.25 }}>
          {s.name}
        </h3>
        <p style={{ margin: '0 0 14px', fontSize: 13.5, color: 'rgba(255,255,255,0.88)', lineHeight: 1.55 }}>
          {s.desc}
        </p>
        <span style={{
          display: 'inline-flex', alignItems: 'center', gap: 6,
          fontSize: 13, fontWeight: 700, color: '#fff',
          transform: hov ? 'translateX(4px)' : 'none',
          transition: 'transform 0.25s ease',
        }}>
          Découvrir →
        </span>
      </div>
    </div>
  );
}

function SecteursSection({ isMobile, onSelectItem }) {
  return (
    <section id="secteurs" style={{ padding: 'clamp(70px,10vw,110px) clamp(16px,5vw,32px)', background: C.bgSoft }}>
      <div style={{ maxWidth: 1280, margin: '0 auto' }}>
        <SectionHead eyebrow="Nos secteurs d'expertise" title="Nos métiers"
          subtitle="Une expertise métier, des solutions adaptées à chaque activité." />
        <div style={{
          display: 'grid',
          gridTemplateColumns: isMobile ? '1fr' : 'repeat(3, 1fr)',
          gap: 22,
        }}>
          {SECTEURS.map((s, i) => (
            <SecteurCard key={i} s={s}
              onOpen={onSelectItem ? () => onSelectItem('secteur', slugify(s.name)) : undefined} />
          ))}
        </div>
      </div>
    </section>
  );
}
/* ════════════════════════════════════════════════════════════
   SERVICES
════════════════════════════════════════════════════════════ */
function ServicesSection({ isMobile, onSelectItem }) {
  return (
    <section id="services" style={{ padding: 'clamp(70px,10vw,110px) clamp(16px,5vw,32px)' }}>
      <div style={{ maxWidth: 1280, margin: '0 auto' }}>
        <SectionHead eyebrow="Ce que nous faisons" title="Nos services"
          subtitle="Un accompagnement complet, de l'installation à l'assistance quotidienne." />
        <div style={{
          display: 'grid', gridTemplateColumns: isMobile ? '1fr' : 'repeat(4,1fr)', gap: 20,
        }}>
          {SERVICES.map((s, i) => (
            <Card key={i} style={{ padding: 26, textAlign: 'center', cursor: onSelectItem ? 'pointer' : 'default' }}
              onClick={onSelectItem ? () => onSelectItem('service', slugify(s.title)) : undefined}>
              <div style={{
                width: 60, height: 60, borderRadius: 16, margin: '0 auto 18px',
                background: `linear-gradient(135deg, ${C.primary}15, #7c3aed15)`,
                display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 28,
              }}>{s.icon}</div>
              <h3 style={{ margin: '0 0 10px', fontSize: 16.5, fontWeight: 800, color: C.text }}>{s.title}</h3>
              <p style={{ margin: 0, fontSize: 13.5, color: C.textSoft, lineHeight: 1.6 }}>{s.desc}</p>
            </Card>
          ))}
        </div>
      </div>
    </section>
  );
}

/* ════════════════════════════════════════════════════════════
   PROCESSUS (steps)
════════════════════════════════════════════════════════════ */
function StepItem({ step, i, isLast }) {
  const [ref, vis] = useReveal(0.2);
  return (
    <div ref={ref} style={{
      display: 'flex', gap: 20, padding: '20px 0',
      borderBottom: !isLast ? `1px solid ${C.border}` : 'none',
      opacity: vis ? 1 : 0, transform: vis ? 'none' : 'translateX(-16px)',
      transition: `all 0.5s ease ${i * 0.05}s`,
    }}>
      <div style={{
        flexShrink: 0, width: 44, height: 44, borderRadius: 12,
        background: `linear-gradient(135deg, ${C.primary}, #7c3aed)`,
        color: '#fff', display: 'flex', alignItems: 'center', justifyContent: 'center',
        fontWeight: 900, fontSize: 17,
      }}>{step.num}</div>
      <div>
        <h4 style={{ margin: '0 0 4px', fontSize: 16.5, fontWeight: 800, color: C.text }}>{step.title}</h4>
        <p style={{ margin: 0, fontSize: 14, color: C.textSoft, lineHeight: 1.6 }}>{step.desc}</p>
      </div>
    </div>
  );
}

function ProcessSection() {
  return (
    <section style={{ padding: 'clamp(70px,10vw,110px) clamp(16px,5vw,32px)', background: C.bgSoft }}>
      <div style={{ maxWidth: 980, margin: '0 auto' }}>
        <SectionHead eyebrow="Votre parcours" title="Comment ça marche ?"
          subtitle="Un parcours transparent, de A à Z, à chaque étape pour garantir votre succès." />
        <div style={{ display: 'flex', flexDirection: 'column', gap: 4 }}>
          {STEPS.map((step, i) => (
            <StepItem key={i} step={step} i={i} isLast={i === STEPS.length - 1} />
          ))}
        </div>
      </div>
    </section>
  );
}

/* ════════════════════════════════════════════════════════════
   POURQUOI NOUS (points forts)
════════════════════════════════════════════════════════════ */
function PourquoiSection({ isMobile }) {
  return (
    <section id="pourquoi" style={{ padding: 'clamp(70px,10vw,110px) clamp(16px,5vw,32px)' }}>
      <div style={{ maxWidth: 1280, margin: '0 auto' }}>
        <SectionHead eyebrow="Nos piliers" title="Pourquoi choisir Bi Data"
          subtitle="La garantie BIDATA, c'est vous équiper de systèmes d'encaissement accessibles, fiables et complets." />
        <div style={{
          display: 'grid', gridTemplateColumns: isMobile ? 'repeat(2,1fr)' : 'repeat(4,1fr)', gap: 20,
        }}>
          {POINTS_FORTS.map((p, i) => (
            <Card key={i} style={{ padding: '30px 20px', textAlign: 'center' }}>
              <div style={{ fontSize: 34, marginBottom: 14 }}>{p.icon}</div>
              <h3 style={{ margin: '0 0 8px', fontSize: 16.5, fontWeight: 800, color: C.text }}>{p.title}</h3>
              <p style={{ margin: 0, fontSize: 13, color: C.textSoft, lineHeight: 1.55 }}>{p.desc}</p>
            </Card>
          ))}
        </div>
      </div>
    </section>
  );
}

/* ════════════════════════════════════════════════════════════
   TÉMOIGNAGES
════════════════════════════════════════════════════════════ */
function TemoignagesSection({ isMobile, onContact }) {
  return (
    <section id="avis" style={{ padding: 'clamp(70px,10vw,110px) clamp(16px,5vw,32px)', background: C.bgSoft }}>
      <div style={{ maxWidth: 1280, margin: '0 auto' }}>
        <SectionHead eyebrow="Avis clients" title="Rejoignez nos clients"
          subtitle="BIDATA, le partenaire de confiance capable de vous équiper et vous accompagner de A à Z." />
        <div style={{
          display: 'grid', gridTemplateColumns: isMobile ? '1fr' : 'repeat(3,1fr)', gap: 20, marginBottom: 50,
        }}>
          {TEMOIGNAGES.map((t, i) => (
            <Card key={i} style={{ padding: 26 }}>
              <div style={{ display: 'flex', gap: 3, marginBottom: 14 }}>
                {Array.from({ length: t.stars }).map((_, j) => (
                  <span key={j} style={{ color: C.gold, fontSize: 15 }}>★</span>
                ))}
              </div>
              <p style={{ margin: '0 0 16px', fontSize: 14, color: C.text, lineHeight: 1.7, fontStyle: 'italic' }}>
                "{t.text}"
              </p>
              <div style={{ fontSize: 12.5, color: C.textSoft, fontWeight: 700 }}>{t.author}</div>
            </Card>
          ))}
        </div>

        <div style={{
          background: `linear-gradient(135deg, ${C.bgDark}, #16213d)`,
          borderRadius: 24, padding: 'clamp(36px,6vw,60px)', textAlign: 'center',
          position: 'relative', overflow: 'hidden',
        }}>
          <div style={{ position: 'absolute', top: -80, right: -60, width: 260, height: 260, borderRadius: '50%',
            background: 'radial-gradient(circle, rgba(37,84,246,0.35), transparent 70%)', filter: 'blur(20px)' }} />
          <h3 style={{ margin: '0 0 12px', fontSize: 'clamp(24px,3.6vw,34px)', fontWeight: 900, color: '#fff', position: 'relative' }}>
            Prêt à passer à la vitesse supérieure ?
          </h3>
          <p style={{ margin: '0 0 28px', fontSize: 15, color: 'rgba(255,255,255,0.7)', maxWidth: 520, marginLeft: 'auto', marginRight: 'auto', position: 'relative' }}>
            Découvrez nos produits et services, ou contactez notre équipe pour une démonstration personnalisée.
          </p>
          <div style={{ display: 'flex', gap: 14, justifyContent: 'center', flexWrap: 'wrap', position: 'relative' }}>
            <PrimaryButton big onClick={onContact}>✉️ Contactez-nous</PrimaryButton>
          </div>
        </div>
      </div>
    </section>
  );
}

/* ════════════════════════════════════════════════════════════
   PAGE SOLUTION — fiche dédiée pour un produit / service / secteur,
   ouverte depuis le méga-menu (comme /solutions/bornes sur softavera.com)
════════════════════════════════════════════════════════════ */
const TYPE_META = {
  produit: { crumb: 'Solutions', backLabel: 'Toutes les solutions' },
  service: { crumb: 'Solutions',  backLabel: 'Toutes les solutions' },
  secteur: { crumb: 'Métiers',    backLabel: 'Tous les métiers' },
};
/* ── Carte d'un modèle (style orange, comme la maquette) ── */
function ModelCard({ m, onContact }) {
  const [hov, setHov] = useState(false);
  return (
    <div
      onMouseEnter={() => setHov(true)} onMouseLeave={() => setHov(false)}
      onClick={onContact}
      role="button" tabIndex={0}
      onKeyDown={e => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); onContact(); } }}
      title="Demander un devis"
      style={{
        flex: '0 0 auto', width: 270, scrollSnapAlign: 'start',
        position: 'relative', overflow: 'hidden', color: '#fff',
        borderRadius: 28, padding: 22, minHeight: 500,
        display: 'flex', flexDirection: 'column',
        cursor: 'pointer',
        background: `linear-gradient(135deg, ${C.primary} 0%, ${C.primaryD} 100%)`,
        boxShadow: hov ? '0 22px 44px -14px rgba(37,84,246,0.55)' : '0 10px 26px -12px rgba(37,84,246,0.4)',
        transform: hov ? 'translateY(-6px)' : 'none',
        transition: 'all 0.35s cubic-bezier(0.22,1,0.36,1)',
      }}
    >
      {/* cercles décoratifs */}
      <div style={{ position: 'absolute', top: -40, right: -30, width: 160, height: 160, borderRadius: '50%',
        background: 'rgba(255,255,255,0.08)', pointerEvents: 'none' }} />
      <div style={{ position: 'absolute', bottom: -60, right: 40, width: 120, height: 120, borderRadius: '50%',
        background: 'rgba(255,255,255,0.06)', pointerEvents: 'none' }} />

      <div style={{ position: 'relative', display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: 10,
        paddingBottom: 14, borderBottom: '1px solid rgba(255,255,255,0.3)' }}>
        <h3 style={{ margin: 0, fontSize: 20, fontWeight: 800 }}>{m.name}</h3>
        <span style={{
          width: 38, height: 38, borderRadius: '50%', background: '#fff', color: C.primary,
          fontSize: 16, fontWeight: 800, flexShrink: 0,
          display: 'flex', alignItems: 'center', justifyContent: 'center',
        }}>↗</span>
      </div>

      <p style={{ position: 'relative', margin: '14px 0 10px', fontSize: 13.5, lineHeight: 1.55, color: 'rgba(255,255,255,0.95)' }}>{m.desc}</p>
      {m.points && (
        <ul style={{ position: 'relative', margin: 0, paddingLeft: 18, fontSize: 13, lineHeight: 1.6, color: 'rgba(255,255,255,0.95)' }}>
          {m.points.map((p, i) => <li key={i}>{p}</li>)}
        </ul>
      )}

      <div style={{ position: 'relative', marginTop: 'auto', paddingTop: 16 }}>
        <div style={{
          background: '#f1f5f9', borderRadius: 20, height: 200, padding: 14,
          display: 'flex', alignItems: 'center', justifyContent: 'center',
        }}>
          <img src={m.img} alt={m.name}
            style={{ maxWidth: '100%', maxHeight: '100%', objectFit: 'contain',
              transform: hov ? 'scale(1.06)' : 'scale(1)', transition: 'transform 0.35s ease' }}
            onError={e => { e.target.style.display = 'none'; }} />
        </div>
      </div>
    </div>
  );
}

/* ── Carrousel de modèles avec flèches + points ── */
function ModelsCarousel({ title, models, isMobile, onContact }) {
  const ref = useRef(null);
  const [idx, setIdx] = useState(0);
  const step = () => (ref.current?.firstChild?.offsetWidth || 270) + 16;
  const scrollDir = (d) => ref.current?.scrollBy({ left: d * step(), behavior: 'smooth' });
  const onScroll = () => ref.current && setIdx(Math.round(ref.current.scrollLeft / step()));
  const needArrows = models.length > (isMobile ? 1 : 4);

  const arrowStyle = (side) => ({
    position: 'absolute', top: '50%', [side]: 0, transform: 'translateY(-50%)', zIndex: 3,
    width: 42, height: 42, borderRadius: '50%', border: `1px solid ${C.border}`,
    background: '#fff', color: '#f2662d', fontSize: 20, cursor: 'pointer',
    boxShadow: '0 6px 18px rgba(15,23,42,0.15)',
  });

  return (
    <section style={{ padding: 'clamp(50px,7vw,90px) clamp(16px,5vw,32px)', background: C.bgSoft }}>
      <div style={{ maxWidth: 1280, margin: '0 auto' }}>
        <SectionHead eyebrow="Nos modèles" title={`Découvrez nos ${title.toLowerCase()}`}
          subtitle="Choisissez le modèle adapté à votre espace et à votre activité." />

        <div style={{ position: 'relative', padding: needArrows ? '0 54px' : 0 }}>
          {needArrows && <button onClick={() => scrollDir(-1)} style={arrowStyle('left')}>‹</button>}
          {needArrows && <button onClick={() => scrollDir(1)} style={arrowStyle('right')}>›</button>}

          <div ref={ref} onScroll={onScroll} className="no-scrollbar" style={{
            display: 'flex', gap: 16, overflowX: 'auto', scrollSnapType: 'x mandatory',
            padding: '10px 4px 20px',
            justifyContent: !needArrows ? 'center' : 'flex-start',
          }}>
            {models.map((m, i) => <ModelCard key={i} m={m} onContact={onContact} />)}
          </div>
        </div>

        {/* points de pagination */}
        {needArrows && (
          <div style={{ display: 'flex', gap: 8, justifyContent: 'center', marginTop: 6 }}>
            {models.map((_, i) => (
              <span key={i} style={{
                height: 8, width: i === idx ? 24 : 8, borderRadius: 999,
                background: i === idx ? '#f2662d' : '#cbd5e1', transition: 'all 0.25s ease',
              }} />
            ))}
          </div>
        )}
      </div>
    </section>
  );
}
function SolutionPage({ type, item, isMobile, onContact, onSelectItem, onGoHome }) {
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'instant' in window ? 'instant' : 'auto' });
  }, [item]);

  const meta = TYPE_META[type];
  const title = type === 'secteur' ? item.name : item.title;
  const color = item.color || C.primary;
  const colorD = item.colorD || C.primaryD;
  const features = item.features || [];
  const secteurImg = type === 'secteur' ? item.img : null;

  let related = [];
  if (type === 'produit') {
    related = PRODUITS.filter(p => p.menuGroup === item.menuGroup && p.title !== item.title)
      .map(p => ({ label: p.title, type: 'produit', slug: slugify(p.title) }));
  } else if (type === 'service') {
    related = SERVICES.filter(s => s.title !== item.title).map(s => ({ label: s.title, type: 'service', slug: slugify(s.title) }));
  } else if (type === 'secteur') {
    related = SECTEURS.filter(s => s.name !== item.name).slice(0, 6).map(s => ({ label: s.name, type: 'secteur', slug: slugify(s.name) }));
  }

  const heroImg = secteurImg || item.img || null;

  return (
    <div style={{ background: C.bg, color: C.text, minHeight: '100vh' }}>
      {/* Hero immersif avec image de fond et boutons bleus */}
      <section style={{
        position: 'relative',
        minHeight: '82vh',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        paddingTop: isMobile ? 110 : 140,
        paddingBottom: isMobile ? 70 : 90,
        paddingLeft: 'clamp(16px,5vw,32px)',
        paddingRight: 'clamp(16px,5vw,32px)',
        overflow: 'hidden',
      }}>
        {/* Arrière-plan photo ou gradient */}
        {heroImg ? (
          <img
            src={heroImg}
            alt={title}
            style={{
              position: 'absolute',
              inset: 0,
              width: '100%',
              height: '100%',
              objectFit: 'contain',
              zIndex: 0,
              filter: 'brightness(0.5) contrast(1.1)',
              pointerEvents: 'none',
            }}
            onError={e => { e.target.style.display = 'none'; }}
          />
        ) : (
          <div style={{
            position: 'absolute',
            inset: 0,
            zIndex: 0,
            background: `linear-gradient(135deg, ${C.primary} 0%, ${C.bgDark} 100%)`,
          }} />
        )}

        {/* Voile dégradé avec teinte bleue */}
        <div style={{
          position: 'absolute',
          inset: 0,
          zIndex: 1,
          pointerEvents: 'none',
          background: 'linear-gradient(180deg, rgba(11, 18, 32, 0.72) 0%, rgba(11, 18, 32, 0.5) 60%, rgba(11, 18, 32, 0.85) 100%)',
        }} />

        {/* Contenu principal */}
        <div style={{
          maxWidth: 950,
          margin: '0 auto',
          position: 'relative',
          zIndex: 2,
          textAlign: 'center',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
        }}>
          <h1 style={{
            margin: '0 0 22px',
            fontWeight: 900,
            letterSpacing: '-0.02em',
            lineHeight: 1.2,
            fontSize: 'clamp(32px, 5vw, 54px)',
            color: '#ffffff',
          }}>
            Des solutions digitales pensées pour{' '}
            <span style={{
              display: 'inline-block',
              background: C.primary,
              color: '#ffffff',
              padding: '2px 14px',
              borderRadius: 8,
              boxShadow: '0 8px 24px rgba(37, 84, 246, 0.45)',
            }}>
              {title.toLowerCase()}
            </span>
          </h1>

          <p style={{
            margin: '0 auto 36px',
            fontSize: 'clamp(16px, 1.9vw, 19px)',
            color: 'rgba(255, 255, 255, 0.9)',
            lineHeight: 1.6,
            maxWidth: 680,
            textShadow: '0 2px 6px rgba(0,0,0,0.4)',
          }}>
            {item.desc}
          </p>

          {/* Boutons d'action bleus */}
          <div style={{ display: 'flex', gap: 14, flexWrap: 'wrap', justifyContent: 'center' }}>
            <PrimaryButton big onClick={onContact}>
              Je demande une démo →
            </PrimaryButton>
            <button
              onClick={onGoHome}
              style={{
                display: 'inline-flex',
                alignItems: 'center',
                gap: 8,
                padding: '16px 28px',
                borderRadius: 12,
                border: '1.5px solid rgba(255, 255, 255, 0.4)',
                background: 'rgba(255, 255, 255, 0.15)',
                backdropFilter: 'blur(10px)',
                color: '#fff',
                cursor: 'pointer',
                fontSize: 15,
                fontWeight: 700,
                fontFamily: FONT,
                transition: 'all 0.25s ease',
              }}
              onMouseEnter={e => {
                e.currentTarget.style.background = 'rgba(255, 255, 255, 0.25)';
                e.currentTarget.style.borderColor = '#fff';
              }}
              onMouseLeave={e => {
                e.currentTarget.style.background = 'rgba(255, 255, 255, 0.15)';
                e.currentTarget.style.borderColor = 'rgba(255, 255, 255, 0.4)';
              }}
            >
              ← {meta.backLabel}
            </button>
          </div>
        </div>

        {/* Fil d'Ariane en bas à gauche */}
        <div style={{
          position: 'absolute',
          bottom: 22,
          left: 'clamp(16px, 5vw, 32px)',
          zIndex: 3,
          display: 'flex',
          alignItems: 'center',
          gap: 8,
          fontSize: 13,
          color: 'rgba(255, 255, 255, 0.8)',
        }}>
          <span style={{ color: '#60a5fa', fontWeight: 700 }}>{meta.crumb}</span>
          <span style={{ opacity: 0.6 }}>›</span>
          <span style={{ color: '#fff', fontWeight: 600 }}>{title}</span>
        </div>
      </section>
{/* Modèles du produit */}
{item.models && item.models.length > 0 && (
  <ModelsCarousel title={title} models={item.models} isMobile={isMobile} onContact={onContact} />
)}
      {/* Points forts */}
      {features.length > 0 && (
        <section style={{ padding: 'clamp(50px, 7vw, 90px) clamp(16px, 5vw, 32px)', background: C.bgSoft }}>
          <div style={{ maxWidth: 1280, margin: '0 auto' }}>
            <SectionHead eyebrow="Ce qui change pour vous" title="Points forts" />
            <div style={{ display: 'grid', gridTemplateColumns: isMobile ? '1fr' : 'repeat(2, 1fr)', gap: 18 }}>
              {features.map((f, i) => (
                <Card key={i} style={{ padding: '22px 24px', display: 'flex', gap: 16, alignItems: 'center' }}>
                  <div style={{
                    flexShrink: 0,
                    width: 36,
                    height: 36,
                    borderRadius: 10,
                    background: `linear-gradient(135deg, ${C.primary}, ${C.primaryD})`,
                    color: '#fff',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    fontSize: 15,
                    fontWeight: 800,
                    boxShadow: '0 4px 12px rgba(37, 84, 246, 0.3)',
                  }}>
                    ✓
                  </div>
                  <p style={{ margin: 0, fontSize: 15, color: C.text, lineHeight: 1.5, fontWeight: 600 }}>
                    {f}
                  </p>
                </Card>
              ))}
            </div>
          </div>
        </section>
      )}

      {/* À découvrir aussi */}
      {related.length > 0 && (
        <section style={{ padding: 'clamp(50px, 7vw, 90px) clamp(16px, 5vw, 32px)' }}>
          <div style={{ maxWidth: 1280, margin: '0 auto' }}>
            <SectionHead eyebrow="Complétez votre équipement" title="À découvrir aussi" />
            <div style={{ display: 'flex', flexWrap: 'wrap', gap: 12, justifyContent: 'center' }}>
              {related.map((r, i) => (
                <button
                  key={i}
                  onClick={() => onSelectItem(r.type, r.slug)}
                  style={{
                    padding: '12px 22px',
                    borderRadius: 999,
                    border: `1.5px solid ${C.border}`,
                    background: '#fff',
                    color: C.text,
                    fontFamily: FONT,
                    fontSize: 14,
                    fontWeight: 700,
                    cursor: 'pointer',
                    transition: 'all 0.2s ease',
                  }}
                  onMouseEnter={e => {
                    e.currentTarget.style.borderColor = C.primary;
                    e.currentTarget.style.color = C.primary;
                    e.currentTarget.style.background = 'rgba(37, 84, 246, 0.05)';
                  }}
                  onMouseLeave={e => {
                    e.currentTarget.style.borderColor = C.border;
                    e.currentTarget.style.color = C.text;
                    e.currentTarget.style.background = '#fff';
                  }}
                >
                  {r.label} →
                </button>
              ))}
            </div>
          </div>
        </section>
      )}

      {/* CTA final */}
      <section style={{ padding: '0 clamp(16px, 5vw, 32px) clamp(60px, 8vw, 90px)' }}>
        <div style={{
          maxWidth: 1280,
          margin: '0 auto',
          background: `linear-gradient(135deg, ${C.bgDark}, #16213d)`,
          borderRadius: 24,
          padding: 'clamp(36px, 6vw, 60px)',
          textAlign: 'center',
          position: 'relative',
          overflow: 'hidden',
        }}>
          <div style={{
            position: 'absolute',
            top: -80,
            right: -60,
            width: 260,
            height: 260,
            borderRadius: '50%',
            background: 'radial-gradient(circle, rgba(37,84,246,0.35), transparent 70%)',
            filter: 'blur(20px)',
          }} />
          <h3 style={{
            margin: '0 0 12px',
            fontSize: 'clamp(22px, 3.4vw, 32px)',
            fontWeight: 900,
            color: '#fff',
            position: 'relative',
          }}>
            Un projet autour de {title.toLowerCase()} ?
          </h3>
          <p style={{
            margin: '0 0 28px',
            fontSize: 15,
            color: 'rgba(255,255,255,0.7)',
            maxWidth: 520,
            marginLeft: 'auto',
            marginRight: 'auto',
            position: 'relative',
          }}>
            Parlons de vos besoins : notre équipe vous propose une solution sur mesure, installation et formation incluses.
          </p>
          <div style={{ display: 'flex', gap: 14, justifyContent: 'center', flexWrap: 'wrap', position: 'relative' }}>
            <PrimaryButton big onClick={onContact}>
              ✉️ Contactez-nous
            </PrimaryButton>
          </div>
        </div>
      </section>
    </div>
  );
}

/* ════════════════════════════════════════════════════════════
   CONTACT MODAL (formulaire en une étape) + FOOTER
════════════════════════════════════════════════════════════ */
const VALUE_PROPS = [
  "17 ans d'expérience en solutions d'encaissement",
  'Installation, formation et support inclus',
  'Support technique disponible de 9h30 à 19h',
  "Une solution pensée pour votre activité",
];

function ContactModal({ open, onClose }) {
  const isMobile = useIsMobile();
  const [secteur, setSecteur] = useState('');
  const [interet, setInteret] = useState('');
  const [form, setForm] = useState({ nom: '', email: '', tel: '', entreprise: '', message: '' });
  const [errors, setErrors] = useState({});
  const [submitted, setSubmitted] = useState(false);

  if (!open) return null;

  const inputStyle = {
    width: '100%', padding: '11px 14px', borderRadius: 10,
    border: `1.5px solid ${C.border}`, fontSize: 14, fontFamily: FONT,
    outline: 'none', boxSizing: 'border-box', color: C.text,
  };
  const selectStyle = { ...inputStyle, cursor: 'pointer', background: '#fff' };
  const labelStyle = { fontSize: 12, fontWeight: 700, color: C.textSoft, marginBottom: 6, display: 'block' };
  const errStyle = { fontSize: 11, color: '#ef4444' };

  const reset = () => {
    setSecteur(''); setInteret('');
    setForm({ nom: '', email: '', tel: '', entreprise: '', message: '' });
    setErrors({}); setSubmitted(false);
  };
  const close = () => { onClose(); reset(); };

 const handleSubmit = async () => {
  const e = {};
  if (!secteur) e.secteur = 'Champ requis.';
  if (!interet) e.interet = 'Champ requis.';
  if (!form.nom.trim()) e.nom = 'Champ requis.';
  if (!form.email.trim()) e.email = 'Champ requis.';
  else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(form.email)) e.email = 'Email invalide.';
  if (form.tel && !/^\d+$/.test(form.tel)) e.tel = 'Chiffres uniquement.';
  if (!form.message.trim()) e.message = 'Champ requis.';
  setErrors(e);
  if (Object.keys(e).length > 0) return;

  try {
    const res = await fetch('/api/contact', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        secteur,
        interet,
        nom: form.nom,
        email: form.email,
        tel: form.tel,
        entreprise: form.entreprise,
        message: form.message,
      }),
    });
    const data = await res.json();
    if (!data.success) {
      setErrors({ message: data.message || 'Une erreur est survenue.' });
      return;
    }
    setSubmitted(true);
  } catch (err) {
    setErrors({ message: 'Impossible de contacter le serveur. Réessayez plus tard.' });
  }
};

  const gridPartners = Array.from({ length: 9 }, (_, i) => PARTNERS[i % PARTNERS.length]);

  return (
    <div onClick={close} style={{
      position: 'fixed', inset: 0, zIndex: 9999, background: 'rgba(15,23,42,0.6)',
      backdropFilter: 'blur(6px)', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 16,
    }}>
      <div onClick={e => e.stopPropagation()} style={{
        background: '#fff', borderRadius: 22, width: '100%', maxWidth: 980, maxHeight: '92vh',
        overflow: 'hidden', boxShadow: '0 40px 100px rgba(0,0,0,0.35)',
        display: 'flex', flexDirection: isMobile ? 'column' : 'row',
      }}>
        {/* Panneau gauche — valeurs & confiance (masqué en mobile pour prioriser le formulaire) */}
        {!isMobile && (
          <div style={{
            width: 360, flexShrink: 0, padding: '42px 36px', overflowY: 'auto',
            background: `linear-gradient(160deg, ${C.primary} 0%, ${C.primaryD} 60%, #101c48 100%)`,
            color: '#fff', display: 'flex', flexDirection: 'column',
          }}>
            <h2 style={{ margin: '0 0 24px', fontSize: 25, fontWeight: 900, lineHeight: 1.28 }}>
              Développez votre activité<br />avec Bi Data
            </h2>
            <div style={{ display: 'flex', flexDirection: 'column', gap: 13, marginBottom: 32 }}>
              {VALUE_PROPS.map((v, i) => (
                <div key={i} style={{ display: 'flex', gap: 10, alignItems: 'flex-start', fontSize: 13.5, lineHeight: 1.5 }}>
                  <span style={{ fontWeight: 900, flexShrink: 0 }}>✓</span>
                  <span style={{ color: 'rgba(255,255,255,0.92)' }}>{v}</span>
                </div>
              ))}
            </div>
            <div style={{
              fontSize: 11.5, fontWeight: 700, letterSpacing: '0.6px', textTransform: 'uppercase',
              color: 'rgba(255,255,255,0.65)', marginBottom: 14,
            }}>Ils nous font confiance</div>
            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3,1fr)', gap: 10 }}>
              {gridPartners.map((p, i) => (
                <div key={i} style={{
                  background: '#fff', borderRadius: 12, height: 60, padding: 8,
                  display: 'flex', alignItems: 'center', justifyContent: 'center',
                }}>
                  <img src={p.src} alt={p.name} title={p.name}
                    style={{ maxWidth: '100%', maxHeight: '100%', objectFit: 'contain' }}
                    onError={e => { e.target.style.display = 'none'; }} />
                </div>
              ))}
            </div>
          </div>
        )}

        {/* Panneau droit — formulaire en une seule fois */}
        <div style={{
          flex: 1, minWidth: 0, padding: 'clamp(22px,4vw,40px)', overflowY: 'auto',
          display: 'flex', flexDirection: 'column',
        }}>
          <div style={{ display: 'flex', alignItems: 'flex-start', justifyContent: 'space-between', gap: 14, marginBottom: 24 }}>
            <div>
              <h3 style={{ margin: '0 0 6px', fontSize: 22, fontWeight: 900, color: C.text }}>Demandez votre devis</h3>
              {!submitted && (
                <p style={{ margin: 0, fontSize: 14, color: C.textSoft }}>Remplissez le formulaire, nous vous recontactons rapidement.</p>
              )}
            </div>
            <button onClick={close} style={{
              width: 34, height: 34, borderRadius: 10, flexShrink: 0,
              border: `1px solid ${C.border}`, background: C.bgSoft, cursor: 'pointer', fontSize: 15,
            }}>✕</button>
          </div>

          {submitted ? (
            <div style={{ flex: 1, display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', textAlign: 'center', padding: '30px 0' }}>
              <div style={{ fontSize: 48, marginBottom: 16 }}>✅</div>
              <p style={{ fontWeight: 800, fontSize: 19, color: C.text, margin: '0 0 8px' }}>Message envoyé !</p>
              <p style={{ color: C.textSoft, fontSize: 14, margin: 0, maxWidth: 360 }}>
                Merci, nous revenons vers vous rapidement avec une proposition adaptée{secteur ? ` à votre activité (${secteur})` : ''}.
              </p>
            </div>
          ) : (
            <>
              <div style={{ display: 'grid', gridTemplateColumns: isMobile ? '1fr' : '1fr 1fr', gap: 14, marginBottom: 14 }}>
                <div>
                  <label style={labelStyle}>Type d'établissement *</label>
                  <select style={{ ...selectStyle, borderColor: errors.secteur ? '#ef4444' : C.border }}
                    value={secteur} onChange={e => setSecteur(e.target.value)}>
                    <option value="">Sélectionnez...</option>
                    {SECTEURS.map(s => <option key={s.name} value={s.name}>{s.name}</option>)}
                  </select>
                  {errors.secteur && <span style={errStyle}>{errors.secteur}</span>}
                </div>
                <div>
                  <label style={labelStyle}>Solution qui vous intéresse *</label>
                  <select style={{ ...selectStyle, borderColor: errors.interet ? '#ef4444' : C.border }}
                    value={interet} onChange={e => setInteret(e.target.value)}>
                    <option value="">Sélectionnez...</option>
                    {PRODUITS.map(p => <option key={p.title} value={p.title}>{p.title}</option>)}
                  </select>
                  {errors.interet && <span style={errStyle}>{errors.interet}</span>}
                </div>
              </div>

              <div style={{ display: 'grid', gridTemplateColumns: isMobile ? '1fr' : '1fr 1fr', gap: 14, marginBottom: 14 }}>
                <div>
                  <label style={labelStyle}>Nom *</label>
                  <input style={{ ...inputStyle, borderColor: errors.nom ? '#ef4444' : C.border }}
                    value={form.nom} onChange={e => setForm(f => ({ ...f, nom: e.target.value }))} />
                  {errors.nom && <span style={errStyle}>{errors.nom}</span>}
                </div>
                <div>
                  <label style={labelStyle}>Email *</label>
                  <input style={{ ...inputStyle, borderColor: errors.email ? '#ef4444' : C.border }}
                    value={form.email} onChange={e => setForm(f => ({ ...f, email: e.target.value }))} />
                  {errors.email && <span style={errStyle}>{errors.email}</span>}
                </div>
              </div>
              <div style={{ display: 'grid', gridTemplateColumns: isMobile ? '1fr' : '1fr 1fr', gap: 14, marginBottom: 14 }}>
                <div>
                  <label style={labelStyle}>Téléphone</label>
                  <input style={{ ...inputStyle, borderColor: errors.tel ? '#ef4444' : C.border }}
                    value={form.tel} onChange={e => setForm(f => ({ ...f, tel: e.target.value.replace(/\D/g, '') }))} />
                </div>
                <div>
                  <label style={labelStyle}>Entreprise</label>
                  <input style={inputStyle} value={form.entreprise} onChange={e => setForm(f => ({ ...f, entreprise: e.target.value }))} />
                </div>
              </div>
              <div style={{ marginBottom: 4 }}>
                <label style={labelStyle}>Message *</label>
                <textarea rows={3} style={{ ...inputStyle, resize: 'vertical', borderColor: errors.message ? '#ef4444' : C.border }}
                  value={form.message} onChange={e => setForm(f => ({ ...f, message: e.target.value }))} />
                {errors.message && <span style={errStyle}>{errors.message}</span>}
              </div>
            </>
          )}

          {!submitted && (
            <div style={{ marginTop: 'auto', paddingTop: 26 }}>
              <button onClick={handleSubmit} style={{
                width: '100%', padding: '14px 0', borderRadius: 12, border: 'none',
                background: C.primary, color: '#fff', fontWeight: 800, fontSize: 15,
                cursor: 'pointer', letterSpacing: '0.3px',
                fontFamily: FONT, transition: 'background 0.2s ease',
              }}>Envoyer ma demande</button>
              <p style={{ textAlign: 'center', fontSize: 11.5, color: C.textSoft, marginTop: 12 }}>
                En soumettant ce formulaire, vous acceptez d'être contacté par notre équipe commerciale.
              </p>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
const SITE_URL = typeof window !== 'undefined' ? window.location.origin : '';

const LEGAL_LINES = [
  {
    text: 'SASU BI DATA au capital de: 5 000,00 €uro - RCS: Creteil B 852 837 327 - TVA: FR29852837327, 3 bd georges méliès 94350 villiers-sur-marne France TEL : 01 80 916 916 E-mail: contact@bidata.fr',
    href: SITE_URL,
  },
  {
    text: 'SASU BI DATA se réserve la propriété de tous ses produits vendus jusqu\u2019à leurs paiements intégrales, frais annexes et taxes compris. Loi 80 335 de 1980',
    href: SITE_URL,
  },
  {
    text: 'BIDATA© et BEEPOS© sont des marques déposées sous les numéros 4580227 et 4580241 – 2019 tous droits réservés',
    href: SITE_URL,
  },
];
function Footer({ isMobile, onContact }) {
  const items = [
    { icon: '📞', label: 'Téléphone', text: '01 80 916 916', href: 'tel:0180916916' },
    { icon: '✉️', label: 'Email', text: 'contact@bidata.fr', href: 'mailto:contact@bidata.fr' },
    { icon: '🌐', label: 'Site web', text: 'www.bidata.fr', href: 'https://www.bidata.fr' },
    { icon: '📍', label: 'Adresse', text: '3 bd Georges Méliès, 94350', href: null },
  ];
  return (
    <footer id="contact" style={{ background: C.bgDark, color: '#fff', padding: 'clamp(50px,8vw,80px) clamp(16px,5vw,32px) 30px' }}>
      <div style={{ maxWidth: 1280, margin: '0 auto' }}>
        <div style={{
          display: 'grid', gridTemplateColumns: isMobile ? '1fr' : 'repeat(4,1fr)', gap: 28,
          paddingBottom: 40, borderBottom: '1px solid rgba(255,255,255,0.1)', marginBottom: 30,
        }}>
          {items.map((it, i) => (
            <a key={i} href={it.href || undefined} target={it.href?.startsWith('http') ? '_blank' : undefined} rel="noreferrer"
              style={{ display: 'flex', gap: 12, alignItems: 'center', textDecoration: 'none', color: '#fff' }}>
              <div style={{
                width: 42, height: 42, borderRadius: '50%', flexShrink: 0,
                background: 'rgba(37,84,246,0.18)', border: '1px solid rgba(37,84,246,0.3)',
                display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 18,
              }}>{it.icon}</div>
              <div>
                <div style={{ fontSize: 10.5, color: 'rgba(255,255,255,0.5)', fontWeight: 700, letterSpacing: '1px', textTransform: 'uppercase' }}>{it.label}</div>
                <div style={{ fontSize: 13.5, fontWeight: 700 }}>{it.text}</div>
              </div>
            </a>
          ))}
        </div>

        <div style={{ display: 'flex', justifyContent: 'space-between', flexWrap: 'wrap', gap: 16, alignItems: 'center' }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
            <img src="images/l.png" alt="Bi Data" style={{ height: 70, width: 'auto', objectFit: 'contain' }} />
          </div>
          <PrimaryButton onClick={onContact}>✉️ Contactez-nous</PrimaryButton>
        </div>
        {/* Legal mentions */}
<div style={{
  marginTop: 30, paddingTop: 24,
  borderTop: '1px solid rgba(255,255,255,0.1)',
  display: 'flex', flexDirection: 'column', gap: 8,
  textAlign: 'center', fontSize: 12, lineHeight: 1.6,
  color: 'rgba(255,255,255,0.5)',
}}>
  {LEGAL_LINES.map((l, i) => (
    <a key={i} href={l.href} rel="noreferrer"
      style={{ color: 'inherit', textDecoration: 'none', transition: 'color 0.2s ease' }}
      onMouseEnter={e => { e.currentTarget.style.color = '#fff'; }}
      onMouseLeave={e => { e.currentTarget.style.color = 'rgba(255,255,255,0.5)'; }}
    >{l.text}</a>
  ))}
  <div style={{ marginTop: 6, color: 'rgba(255,255,255,0.4)' }}>
    © 2021- Création site web par Bidata
  </div>
</div>
      </div>
    </footer>
  );
}

/* ════════════════════════════════════════════════════════════
   KEYFRAMES globaux
════════════════════════════════════════════════════════════ */
const GLOBAL_STYLE = `
  @import url('https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700;800;900&display=swap');
  *, *::before, *::after { box-sizing: border-box; }
  html { scroll-behavior: smooth; }
  body { margin: 0; }
  @keyframes marquee {
    0% { transform: translateX(0); }
    100% { transform: translateX(-33.333%); }
  }
`;

/* ════════════════════════════════════════════════════════════
   ROOT APP
════════════════════════════════════════════════════════════ */
/* Parse un hash du type "#/solutions/produit/bornes-de-commande" en { type, slug } */
function parseHash(hash) {
  const m = /^#\/solutions\/(produit|service|secteur)\/([a-z0-9-]+)$/.exec(hash || '');
  if (!m) return null;
  return { type: m[1], slug: m[2] };
}

export default function App() {
  const isMobile = useIsMobile();
  const [modalOpen, setModalOpen] = useState(false);
  const [view, setView] = useState(() => parseHash(typeof window !== 'undefined' ? window.location.hash : ''));

  // Garde la vue synchronisée avec l'URL (navigation, retour arrière, lien partagé)
  useEffect(() => {
    const onHashChange = () => setView(parseHash(window.location.hash));
    window.addEventListener('hashchange', onHashChange);
    return () => window.removeEventListener('hashchange', onHashChange);
  }, []);

  const goHome = useCallback(() => {
    setView(null);
    if (window.location.hash) window.history.pushState('', document.title, window.location.pathname + window.location.search);
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }, []);

  const selectItem = useCallback((type, slug) => {
    window.location.hash = `#/solutions/${type}/${slug}`;
    setView({ type, slug });
  }, []);

  const scrollTo = useCallback((id) => {
    if (view) {
      // Depuis une fiche, on revient d'abord à l'accueil avant de défiler vers la section
      goHome();
      setTimeout(() => {
        const el = document.getElementById(id);
        if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }, 60);
      return;
    }
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }, [view, goHome]);

  const activeItem = view ? findSolutionItem(view.type, view.slug) : null;

  return (
    <div style={{ fontFamily: FONT, background: C.bg, color: C.text, width: '100%', overflowX: 'hidden' }}>
      <style>{GLOBAL_STYLE}</style>

      <Navbar isMobile={isMobile} onNav={scrollTo} onContact={() => setModalOpen(true)}
        onGoHome={goHome} onSelectItem={selectItem} />

      {view && activeItem ? (
        <SolutionPage type={view.type} item={activeItem} isMobile={isMobile}
          onContact={() => setModalOpen(true)} onSelectItem={selectItem} onGoHome={goHome} />
      ) : (
        <>
          <Hero isMobile={isMobile} onContact={() => setModalOpen(true)} onNav={scrollTo} />
          <PartnersMarquee />
          <ProduitsSection isMobile={isMobile} onContact={() => setModalOpen(true)} onSelectItem={selectItem} />
          <SecteursSection isMobile={isMobile} onSelectItem={selectItem} />
          <ServicesSection isMobile={isMobile} onSelectItem={selectItem} />
          <ProcessSection />
          <PourquoiSection isMobile={isMobile} />
          <TemoignagesSection isMobile={isMobile} onContact={() => setModalOpen(true)} />
        </>
      )}

      <Footer isMobile={isMobile} onContact={() => setModalOpen(true)} />
      <ContactModal open={modalOpen} onClose={() => setModalOpen(false)} />
    </div>
  );
}